const RandomNumber = (min,max) => {
    var result = Math.floor(Math.random() * (max - min)) + min;
    return (result);
};
export default RandomNumber;